export default __webpack_public_path__ + "static/media/BimViewer.bfaab2de.svg";